import { createSelector } from 'reselect'
// import { List } from 'immutable'

const companySelector = state => state.get('company')

export const getIsFetching = createSelector(
  companySelector,
  companyImmutable => {
    const company = companyImmutable.toJS()
    return company.companyCreate.isFetching
    || company.companyEdit.isFetching
    || company.companyGet.isFetching
    || company.companyList.isFetching
    || company.companyExport.isFetching
  }
)
export const getCreateCompanyData = createSelector(
  companySelector,
  companyImmutable => {
    const company = companyImmutable.toJS()
    return company.companyCreate
  }
)
export const getEditCompanyData = createSelector(
  companySelector,
  companyImmutable => {
    const company = companyImmutable.toJS()
    return company.companyEdit
  }
)
export const getDeactivateCompanyData = createSelector(
  companySelector,
  companyImmutable => {
    const company = companyImmutable.toJS()
    return company.companyEdit
  }
)
export const getGetCompanyData = createSelector(
  companySelector,
  companyImmutable => {
    const company = companyImmutable.toJS()
    return company.companyGet.company
  }
)
export const getListCompany = createSelector(
  companySelector,
  companyImmutable => {
    const company = companyImmutable.toJS()
    return company.companyList.company
  }
)
export const getExportURL = createSelector(
  companySelector,
  companyImmutable => {
    const company = companyImmutable.toJS()
    return company.companyExport.url
  }
)
export const redirectCompany = createSelector(
  companySelector,
  companyImmutable => {
    const company = companyImmutable.toJS()
    return ({
      redirect: (company.companyCreate.redirect
      || company.companyEdit.redirect
      || company.companyGet.redirect
      || company.companyList.redirect
      || company.companyExport.redirect),
      isAuthenticated: (company.companyCreate.isAuthenticated
      || company.companyEdit.isAuthenticated
      || company.companyGet.isAuthenticated
      || company.companyList.isAuthenticated
      || company.companyExport.isAuthenticated),
    })
  }
)



// WEBPACK FOOTER //
// ./src/selectors/company/company-selector.js